fragment CollectionsSliderFragment on collectionsSlider_Entry {
  typeHandle
  heading
  collections {
    ... on collectionsSliderCollectionsBlock_Entry {
      image {
        url
        title
      }
      cta {
        ...LinkFragment
      }
    }
  }
}
